export const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    maxWidth: theme.container.maxWidth,
    margin: theme.container.margin
  },
  field: {
    marginLeft: 0,
    marginRight: 0,
    width: "100%"
  },
  formControl: {
    marginLeft: 0,
    marginRight: 0
  },
  grid: {
    margin: "5px"
  },
  gridButton: {
    marginTop: "20px",
    textAlign: "end"
  },
  button: {
    width: "200px"
  },
  error: {
    color: "red"
  },
  subtitle: {
    marginTop: "1.5rem"
  },
  iconHipervinculo: {
    position: "relative",
    top: "27px",
    left: "210px",
    zIndex: "5000"
  }
});
